<mat-card appearance="outlined">
  <div class="iframe-container">
    <div class="disable-iframe"></div>
    @if (domain) {
      <iframe
        [src]="siteUrl()"
        tabindex="-1"
        scrolling="no"
        allowfullscreen
        sandbox="allow-scripts allow-same-origin allow-presentation"
      ></iframe>
    } @else {
      <mat-spinner class="info-spinner" mode="indeterminate" color="accent"></mat-spinner>
    }
  </div>
  <mat-card-subtitle [hidden]="!domain" [innerHTML]="manageSiteModalHeader">
    <br />
  </mat-card-subtitle>
  <mat-card-content class="versions-group">
    @if (_siteUpdate) {
      @if (phpVersion$ | async; as phpVersionValue) {
        <p>
          {{ 'PAGES.OVERVIEW.MANAGE_SITE_MODAL.PHP_VERSION' | translate }}:
          @if (phpVersionValue === '7') {
            <b>7.4.11</b>
          }
          @if (phpVersionValue === '8' || phpVersionValue === '8.1') {
            <b>8.1</b>
          }
          @if (phpVersionValue === '8.2') {
            <b>8.2</b>
          }
          @if (phpVersionValue === '8.3') {
            <b>8.3</b>
          }
          <mat-icon>check_circle</mat-icon>
          <button
            class="change-php-btn"
            mat-button
            color="primary"
            (click)="openModal()"
            id="PHP_Version_Change_Button"
          >
            {{ 'PAGES.OVERVIEW.MANAGE_SITE_MODAL.OPEN_CHANGE_PHP_VERSION_DIALOG_BUTTON' | translate }}
          </button>
        </p>
      }
      <p>
        {{ 'PAGES.OVERVIEW.MANAGE_SITE_MODAL.WORDPRESS_VERSION' | translate }}:
        @if (_siteUpdate.core_version !== null) {
          <b>{{ _siteUpdate.core_version }}</b>
          @if (coreUpToDate) {
            <mat-icon>check_circle</mat-icon>
          } @else {
            <a
              data-action="wordpress-view-core-update"
              data-action-group="open-wordpress"
              class="update-container"
              [href]="updateCoreURL()"
              target="_blank"
            >
              {{ 'PAGES.OVERVIEW.MANAGE_SITE_MODAL.UPDATE_LINK_TEXT' | translate }}
            </a>
          }
        } @else {
          <mat-icon class="warning">warning</mat-icon>
          Error
        }
      </p>
      <p>
        {{ 'PAGES.OVERVIEW.MANAGE_SITE_MODAL.PLUGIN_UPDATES' | translate }}:
        @if (_siteUpdate.num_of_plugin_updates !== null) {
          <b>{{ _siteUpdate.num_of_plugin_updates }}</b>
          @if (_siteUpdate.num_of_plugin_updates === 0) {
            <mat-icon>check_circle</mat-icon>
          } @else {
            <a
              data-action="wordpress-view-plugin-update"
              data-action-group="open-wordpress"
              class="update-container"
              [href]="updatePluginURL()"
              target="_blank"
            >
              {{ 'PAGES.OVERVIEW.MANAGE_SITE_MODAL.UPDATE_LINK_TEXT' | translate }}
            </a>
          }
        } @else {
          <mat-icon class="warning">warning</mat-icon>
          Error
        }
      </p>
      <p>
        {{ 'PAGES.OVERVIEW.MANAGE_SITE_MODAL.THEME_UPDATES' | translate }}:
        @if (_siteUpdate.num_of_theme_updates !== null) {
          <b>{{ _siteUpdate.num_of_theme_updates }}</b>
          @if (_siteUpdate.num_of_theme_updates === 0) {
            <mat-icon>check_circle</mat-icon>
          } @else {
            <a
              data-action="wordpress-view-theme-update"
              data-action-group="open-wordpress"
              class="update-container"
              [href]="updateThemeURL()"
              target="_blank"
            >
              {{ 'PAGES.OVERVIEW.MANAGE_SITE_MODAL.UPDATE_LINK_TEXT' | translate }}
            </a>
          }
        } @else {
          <mat-icon class="warning">warning</mat-icon>
          Error
        }
      </p>
      @if ((editionName$ | async) === MULTISITE_EDITION_NAME && (SubscribedsubsitesCount$ | async) > 0) {
        <p>
          {{ 'PAGES.OVERVIEW.MANAGE_SITE_MODAL.SUBSITE_LIMIT' | translate }}:
          <b>{{ SubscribedsubsitesCount$ | async }}</b>
        </p>
      }
    } @else {
      <mat-spinner class="info-spinner" mode="indeterminate" color="accent"></mat-spinner>
    }
  </mat-card-content>
</mat-card>
